import moment from 'moment'

export default {
  methods: {
    convertToLocationDate (date) {
      const y = moment(date).year()
      const m = moment(date).month()
      const d = moment(date).date()
      const min = moment(date).minute()
      const h = moment(date).hour()
      const s = moment(date).seconds()
      const correctData = new Date(y, m, d, h, min, s)
      return correctData
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/convertToLocationDate.js